import { HiStar, HiExternalLink } from 'react-icons/hi';
import Button from '../components/ui/Button';
import Section, { SectionHeader } from '../components/ui/Section';
import HeroSection from '../components/ui/HeroSection';
import ChalkboardBackground from '../components/ui/ChalkboardBackground';
import testimonials from '../data/testimonials.json';
import siteContent from '../data/siteContent.json';
import homeBg from '../assets/images/bb-background.png';
import reviewsBg from '../assets/images/reviews-banner.png';
import Seo from '../components/Seo';

export default function Testimonials() {
  const allReviews = testimonials.testimonials;

  return (
    <>
      <Seo
        title="Bride Reviews — The Knot Best of Weddings"
        description="Read 5-star reviews from Kansas City brides. Blush & Bobby is a multi-year winner of The Knot Best of Weddings and WeddingWire Couples' Choice Award."
        path="/reviews"
      />
      {/* Hero */}
      <HeroSection title="Reviews" backgroundImage={reviewsBg} />

      {/* All Reviews */}
      <Section background="white">
        <SectionHeader
          title="What Brides Are Saying"
          subtitle="Kind words from our beautiful brides"
          titleColor="text-dusty-rose"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {allReviews.map((review) => (
            <div
              key={review.id}
              className="bg-cream p-6 rounded-2xl shadow-md"
            >
              <div className="mb-4">
                <p className="font-semibold text-sm text-dusty-rose">{review.name}</p>
                <p className="text-xs text-gray-500">{review.date}</p>
              </div>
                <div className="flex mb-3">
                  {[...Array(5)].map((_, i) => (
                    <HiStar key={i} className="h-4 w-4 text-dusty-rose" />
                  ))}
                </div>
              <p className="text-gray-600 text-sm">"{review.text}"</p>
            </div>
          ))}
        </div>
      </Section>

      {/* External Reviews */}
      <div className="relative py-12 md:py-16 lg:py-20 bg-cream checkered-bg overflow-hidden">
        {/* Pink transparency overlay */}
        <div className="absolute inset-0 bg-dusty-rose/50 z-10" />
        
        <div className="container-custom relative z-20 text-center max-w-2xl mx-auto">
          <h2 className="font-headline text-2xl md:text-3xl font-semibold mb-4 text-white uppercase tracking-wider">
            See More Reviews
          </h2>
          <p className="text-white mb-6 leading-relaxed font-medium">
            Check out our profiles on The Knot and Wedding Wire for even more reviews from happy brides.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              href={siteContent.social.theKnot}
              target="_blank"
              rel="noopener noreferrer"
              variant="white"
            >
              View on The Knot
            </Button>
            <Button
              href={siteContent.social.weddingWire}
              target="_blank"
              rel="noopener noreferrer"
              variant="white"
            >
              View on Wedding Wire
            </Button>
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <ChalkboardBackground 
        as="section" 
        backgroundImage={homeBg}
        backgroundOpacity={0.5}
        className="py-12 md:py-16 lg:py-20"
      >
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-headline font-semibold mb-6 text-chalk uppercase tracking-wider">
              Let's Create Your Dream Look
            </h2>
            <Button
              href={siteContent.social.linktree}
              target="_blank"
              rel="noopener noreferrer"
              variant="outline"
              size="lg"
              className="!text-xs"
            >
              Check Availability
              <HiExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </ChalkboardBackground>
    </>
  );
}
